// Sigla documento (SF/FA/OSS/...). Se manca doc_type ma c'è review_reason,
// mostra ⚠ col motivo in tooltip (proposta finita in revisione manuale).
// Colore PER SIGLA (richiesta Davide 15/07). Redesign 27/10: forma e palette
// dei badge della lista ordini, a CONTORNO — la sigla e' un'etichetta, lo
// stato accanto e' il badge pieno, e i due non si confondono.
import { contorno, FORMA_BADGE, type StatoTone } from "@/features/ordini/components/statoToni";
import type { DocType } from "../types";

export const TONO_SIGLA: Record<DocType, StatoTone> = {
  SF: "pronto",
  FA: "sost-fornitore",
  OSS: "gia-spedita",
  FA41: "da-pagare-atteso",
  FA8: "ldv-mancante",
  ST: "da-pagare",
  RC: "da-pagare",
  RCO: "da-pagare",
};

export function DocTypeBadge({
  docType,
  reviewReason,
}: {
  docType: DocType | null;
  reviewReason: string | null;
}) {
  if (!docType) {
    return (
      <span className="text-[12px] text-ink-2" title={reviewReason ?? undefined}>
        da decidere{reviewReason ? " ⚠" : ""}
      </span>
    );
  }
  return (
    <span
      data-tono={TONO_SIGLA[docType] ?? "annullato"}
      className={FORMA_BADGE}
      style={contorno(TONO_SIGLA[docType] ?? "annullato")}
      title={reviewReason ?? undefined}
    >
      {docType}
      {reviewReason ? "⚠" : ""}
    </span>
  );
}
